import React, { useRef } from "react";

const Pricing = ({ heroRef }) => {
  const scrollToHero = () => {
    if (heroRef && heroRef.current) {
      heroRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const plans = [
    {
      title: "Monthly",
      price: "₹ 12,999",
      features: [
        "Completely Automated",
        "Trade Indices",
        "1 Research Indicator",
        "WhatsApp & Call Support",
        "Remote Support",
      ],
    },
    {
      title: "Quarterly",
      price: "₹ 33,999",
      features: [
        "Completely Automated",
        "Trade Indices",
        "3 Research Indicator",
        "WhatsApp & Call Support",
        "Remote Support",
        "₹ 1,000 Maintenance Charge per Month",
      ],
    },
    {
      title: "Half Yearly",
      price: "₹ 51,000",
      features: [
        "Completely Automated",
        "Trade Indices",
        "5-6 Research Indicator",
        "WhatsApp & Call Support",
        "Dedicated Relationship Manager",
        "Remote Support",
        "₹ 1,000 Maintenance Charge per Month",
      ],
    },
    {
      title: "Equity Commodity Combo - Half Yearly",
      price: "₹ 71,000",
      features: [
        "Completely Automated",
        "Trade Indices",
        "7-8 Research Indicator For Equity & Commodity",
        "WhatsApp & Call Support",
        "Dedicated Relationship Manager",
        "Remote Support",
        "₹ 1,000 Maintenance Charge per Month",
      ],
    },
  ];

  return (
    <div className="px-4 bg-white text-black py-10 border">
      <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-8 mt-14">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="border border-gray-300 shadow-lg p-6 rounded-lg bg-white flex flex-col justify-between"
          >
            <div>
              <h3 className="text-sm font-bold text-white p-4 bg-[#2db928] rounded">
                {plan.title}
              </h3>
              <p className="text-lg font-bold text-blue-600 mt-2">{plan.price}</p>
              <ul className="mt-4 space-y-2 text-gray-700">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-center">
                    ✅ {feature}
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-6 text-center">
              <button
                onClick={scrollToHero}
                className="bg-[#2db928] px-6 py-2 rounded-full text-sm text-white font-medium transition duration-300 hover:bg-[#2db928]/80"
              >
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pricing;


// import React,{useRef} from "react";
// //import serviceApi from "../assets/serviceApi.png";
// //import { useNavigate } from "react-router-dom";
// const Pricing = ({ heroRef }) => {
//   const contactRef = useRef(null);
//     const scrollToHero = () => {
//       if (heroRef && heroRef.current) {
//         heroRef.current.scrollIntoView({ behavior: "smooth" });
//       }
//     };

//   //const navigate = useNavigate();
//   const plans = [
//     {
//       title: "Monthly",
//       price: "₹ 12,999",
//       features: [
//         "Completely Automated",
//         "Trade Indices",
//         "1 Research Indicator",
//         "WhatsApp & Call Support",
//         "Remote Support",
//       ],
//     },
//     {
//       title: "Quarterly",
//       price: "₹ 33,999",
//       features: [
//         "Completely Automated",
//         "Trade Indices",
//         "3 Research Indicator",
//         "WhatsApp & Call Support",
//         "Remote Support",
//         "₹ 1,000 Maintenance Charge per Month",
//       ],
//     },
//     {
//       title: "Half Yearly",
//       price: "₹ 51,000",
//       features: [
//         "Completely Automated",
//         "Trade Indices",
//         "5-6 Research Indicator",
//         "WhatsApp & Call Support",
//         "Dedicated Relationship Manager",
//         "Remote Support",
//         "₹ 1,000 Maintenance Charge per Month",
//       ],
//     },
//     {
//       title: "Equity Commodity Combo - Half Yearly",
//       price: "₹ 71,000",
//       features: [
//         "Completely Automated",
//         "Trade Indices",
//         "7-8 Research Indicator For Equity & Commodity",
//         "WhatsApp & Call Support",
//         "Dedicated Relationship Manager",
//         "Remote Support",
//         "₹ 1,000 Maintenance Charge per Month",
//       ],
//     },
//   ];

//   return (
//     <div className="px-4 bg-white text-black py-10 border">
//       {/* <div className="">
//         <p className="text-xl lg:text-center text-left font-bold">
//           Equity Research Mart API bridge Service{" "}
//         </p>
//       </div>
//       <div className="mx-auto my-12  w-full lg:flex px-auto gap-4 ">
//         <div className="lg:w-1/2 lg:px-10 ">
//           <p className="font-semibold">
//             Description for Our Services 'API Bridge'
//           </p>
//           <p className="my-5 lg:text-left text-justify">
//             In the ever-evolving landscape of technology and software
//             applications, the need for seamless communication and data exchange
//             between different systems has become paramount. This is where an API
//             bridge comes into play. An API bridge serves as a virtual connection
//             that enables two or more distinct software applications to interact
//             and share information in real-time. This is applied for all kind of
//             service which is provided by research analyst we are completely
//             research Analyst Company which provides research calls only. We
//             provide only one more facility to our customer they can use this
//             facility for API bridge configuration in penal they have two option
//             to run this advantage one is manual and another is automatic. In
//             this facility customer can set their quantity as per their
//             investment customer may set their quantity and many more facility;
//             we do not have any strategy in this platform these calls given by
//             only research analyst as per market situation. We provide API bridge
//             facility in each of service provided like Option, Cash, Future and
//             MCX
//           </p>
//         </div>
//         <div className="flex lg:w-1/2 lg:border-s lg:shadow-lg shadow-xl border">
//           <img src={serviceApi} alt="" className="lg:h-auto h-60" />
//         </div>
//       </div> */}
//       <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-6 mt-14 h-full">
//         {plans.map((plan, index) => (
//           <div
//             key={index}
//             className="border border-gray-300 shadow-lg p-4 rounded-lg bg-white"
//           >
//             <div className="h-[80%]">
//             <h3 className="text-sm font-bold text-white p-4 bg-[#2db928] ">
//               {plan.title}
//             </h3>
//             <p className="text-lg font-bold text-blue-600 mt-2">{plan.price}</p>
//             <ul className="mt-4 space-y-2 text-gray-700">
//               {plan.features.map((feature, i) => (
//                 <li key={i} className="flex items-center">
//                   ✅ {feature}
//                 </li>
//               ))}
//             </ul>
//             </div>
            
//             <div className="mt-6 text-center" >
//               <button
//                 onClick={scrollToHero}
//                 className="bg-[#2db928] px-4 lg:py-1 rounded-full text-sm text-white font-medium transition-all duration-300 hover:bg-[#2db928]/80 py-2"
//               >
//                 Book Now
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//       </div>
//   );
// };

// export default Pricing;



// import React from "react";
// import choose from "../assets/topo-1.jpg";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import apiendpoints from "../apiendpoints.json"
// function Pricing() {
//   // const prices = [
//   //   // {
//   //   //   heading: "ERM Holding Pack",
//   //   //   id: "EHP",
//   //   //   description:
//   //   //     "A product designed for short term investors who are looking for a passive investment strategy. It follows the Classic Value Investing Strategy. Value investing is the process of doing detective work to find these secret sales on stocks and buying them at a discount compared to how the market values them. In return for buying and holding these value stocks for the long term, thereby delivering meaningful results over the long run.",
//   //   //   src: "",
//   //   //   prices: [
//   //   //     { monthly: null },
//   //   //     { quarterly: null },
//   //   //     { halfYearly: null },
//   //   //     { yearly: "25000" },
//   //   //   ],
//   //   //   features: [
//   //   //     "Positional Research report in Equity Cash Segment",
//   //   //     "5-6 Stocks WITH MISPRICED OPPORTUNITY BASED ON VALUE INVESTING.",
//   //   //     "Holding period can be 6 months to 12 months.",
//   //   //     "Follow up on Quarterly updates via communication channels.",
//   //   //     "Our team periodically monitors these stocks given and portfolio rebalancing applied wherever required. (Early entry or exit can be possible depending on market and pricing scenario).",
//   //   //   ],
//   //   //   investmentRules: [
//   //   //     "Always invest with equal amount of investment. Don't put all your eggs in one basket.",
//   //   //     "Don't average in any stock because it will double your risk. Follow proper risk management.",
//   //   //     "Don't be emotional or greedy while trading. Always take profit home whenever you see good profit and don't panic in case of reverse situation because ups and downs are part of market. Hold your position with proper stop loss.",
//   //   //     "Don't force yourself to be a trader for doing more number of trades because it may spoil quality of trades. We always wait for proper indication to trade and we trade in stable market.",
//   //   //     "Always take risk of your spare capital only. Don't take loan or borrow money from anyone and trade in stock market.",
//   //   //     "This is not a primary source of income. Stock market trading or investments are subject to market risk, so don't depend on this earning.",
//   //   //   ],
//   //   // },
//   //   // {
//   //   //   heading: "ERM WEALTH",
//   //   //   id: "EW",
//   //   //   description:
//   //   //     "A product designed for medium to long term investors who are looking for a strategy which can beat index returns over time.\n While our expert analysts dive into the fundamentals and technical analytics to find the hidden gems in the market, all you need is to sit back and watch your investments grow manifold.",
//   //   //   src: "",
//   //   //   prices: [
//   //   //     { monthly: null },
//   //   //     { quarterly: "31000" },
//   //   //     { halfYearly: null },
//   //   //     { yearly: "70000" },
//   //   //   ],
//   //   //   features: [
//   //   //     "Invest in a highly personalized and concentrated Stock basket of 20-25 stocks.",
//   //   //     "Combination of mid-caps and large caps Stocks.",
//   //   //     "Stock selection done on Strong past track record for a combination of short term, mid term and long term which can be for 3-5 Years.",
//   //   //     "Follow up on Quarterly updates via communication channels.",
//   //   //     "Experts periodically monitor these stocks given and change applied wherever required. (Early entry or exit can be possible depending on market and pricing scenario).",
//   //   //   ],
//   //   //   investmentRules: [],
//   //   // },
//   //   // {
//   //   //   heading: "ERM SWING PACK",
//   //   //   id: "ESP",
//   //   //   description:
//   //   //     "A product dedicated for traders who intend to grab potential trades from Intraday Cash market with swing movement with 2-3 days holding. Traders employ technical analysis to determine when conditions are right to enter either long or short, and then to exit. Short term investors who are looking for an opportunity in a volatile market. It follows the momentum stocks which can give movement by holding good stocks in cash segment.",
//   //   //   src: "",
//   //   //   prices: [
//   //   //     { monthly: null },
//   //   //     { quarterly: "21000" },
//   //   //     { halfYearly: "35000" },
//   //   //     { yearly: null },
//   //   //   ],
//   //   //   features: [
//   //   //     "Only Cash Segment Intraday recommendations in Stocks.",
//   //   //     "Total Recommendations – Weekly 2-3.",
//   //   //     "Service Mode- WHATSAPP/SMS.",
//   //   //     "Follow-Up- Yes.",
//   //   //   ],
//   //   //   investmentRules: [],
//   //   // },
//   //   // {
//   //   //   heading: "ERM Equity & Derivative Combo",
//   //   //   id: "EEDC",
//   //   //   description:
//   //   //     "A product designed for traders who wish to trade with a combination of Equity and Derivative Segment on their Cash investments. ERM Equity Derivative Combo is an exclusive product for speculators who want to trade in the whole equity segment.",
//   //   //   src: "",
//   //   //   prices: [
//   //   //     { monthly: "14000" },
//   //   //     { quarterly: "34000" },
//   //   //     { halfYearly: "49999" },
//   //   //     { yearly: null },
//   //   //   ],
//   //   //   features: [
//   //   //     "Intraday Equity trading, Recommendations in Equity Cash, Futures, and Options.",
//   //   //     "Designed to provide personalized 1-3 Equity recommendations on a daily basis.",
//   //   //     "Purely intraday calls.",
//   //   //     "Total Recommendations – 1-3 Daily.",
//   //   //     "Service Mode- SMS.",
//   //   //     "Follow-Up- Yes.",
//   //   //   ],
//   //   //   investmentRules: [],
//   //   // },
//   //   /*erm stock option pack*/ 
//   //   {
//   //     heading: "ERM Stock OPTION PACK",
//   //     id: "ESOP",
//   //     description:
//   //       "A product dedicated for traders who wish to trade only in Stock Options derivative segment. Options trading tips rely heavily on Options Greeks i.e. Delta, Gamma, Vega, & Theta which are integral to derivative trading. Call & Put tips are aspects of Bullish & Bearish market which helps rise in premium price of Option.",
//   //     src: "",
//   //     prices: [
//   //       { monthly: "12999" },
//   //       { quarterly: "33000" },
//   //       { halfYearly: "59000" },
//   //       { yearly: null },
//   //     ],
//   //     features: [
//   //       "Only Options Buying recommendations Intraday/Positional recommendations in Stocks Options.",
//   //       "Traders who trade in this capacity are generally classified as speculators.",
//   //       "Total Recommendations – 1-2 Daily.",
//   //       "Service Mode- SMS.",
//   //       "Follow-Up- Yes.",
//   //     ],
//   //     investmentRules: [],
//   //   },
      
//   //   // {
//   //   //   heading: "ERM Index (Future & Option)",
//   //   //   id: "EIFO",
//   //   //   description:
//   //   //     "A product dedicated for traders who wish to trade only on Bank Nifty and Nifty Future and Options Weekly/Monthly Expiry special calls. Options trading tips rely heavily on Options Greeks i.e. Delta, Gamma, Vega, & Theta which are integral to derivative trading. Call & Put tips are aspects of Bullish & Bearish market which helps rise in premium price of Option.",
//   //   //   src: "",
//   //   //   prices: [
//   //   //     { monthly: null },
//   //   //     { quarterly: "35000" },
//   //   //     { halfYearly: "61000" },
//   //   //     { yearly: null },
//   //   //   ],
//   //   //   features: [
//   //   //     "Recommendations – 1-3 daily.",
//   //   //     "Service Mode- SMS.",
//   //   //     "Follow-Up- Yes.",
//   //   //   ],
//   //   //   investmentRules: [],
//   //   // },
//   //   // {
//   //   //   heading: "ERM COMMODITY (Base Metal & Energy)",
//   //   //   id: "ECBME",
//   //   //   description:
//   //   //     "A product for traders who aim to trade in the Commodity market. Intraday based recommendation in MCX commodity in the segment of Base Metals and Natural Gas with occasional holding. Ideal for clients who want to trade in the MCX Segment.",
//   //   //   src: "",
//   //   //   prices: [
//   //   //     { monthly: "9000" },
//   //   //     { quarterly: "21000" },
//   //   //     { halfYearly: "35000" },
//   //   //     { yearly: null },
//   //   //   ],
//   //   //   features: [
//   //   //     "Recommendation Frequency- 20-22 monthly.",
//   //   //     "Mode of recommendation- SMS.",
//   //   //     "Follow-Up- Yes.",
//   //   //   ],
//   //   //   investmentRules: [],
//   //   // },
//   //   /*erm full  mcx pack*/ 
//   //   {
//   //     heading: "ERM Full MCX Pack",
//   //     id: "EFMP",
//   //     description:
//   //       "A product designed for traders who aim to grab high potential trades from the Commodity market. Intraday based recommendation in MCX commodity in the segment of Precious metals, Base Metals, and Natural Gas with occasional holding. Ideal for clients who want to trade in MCX Commodities.",
//   //     src: "",
//   //     prices: [
//   //       { monthly: "15000" },
//   //       { quarterly: "40000" },
//   //       { halfYearly: "70000" },
//   //       { yearly: null },
//   //     ],
//   //     features: [
//   //       "Recommendation Frequency- 1-2 Trades Daily.",
//   //       "Mode of recommendation- SMS.",
//   //       "Follow-Up- Yes.",
//   //     ],
//   //     investmentRules: [],
//   //   },
    
//   //     /*erm index option pack*/ 
//   //   {
//   //     heading: "ERM INDEX Option PACK",
//   //     id: "EIOP",
//   //     description:
//   //       "A product dedicated for traders who wish to trade only on Bank Nifty, Nifty, Finnifty Weekly Monthly Expiry special calls. Only Options Buying recommendations. Intraday recommendations in Index Options.",
//   //     src: "",
//   //     prices: [
//   //       { monthly: "9000" },
//   //       { quarterly: "22000" },
//   //       { halfYearly: "35000" },
//   //       { yearly: null },
//   //     ],
//   //     features: [
//   //       "Only Options Buying recommendations.",
//   //       "Intraday recommendations in Index Options.",
//   //       "Total Recommendations – 1-2 recommendations.",
//   //       "Service Mode- SMS.",
//   //       "Follow-Up- Yes.",
//   //     ],
//   //     investmentRules: [],
//   //   },
    
//   // ];
//   const packageVariants = {
//     initial: {
//       opacity: 0,
//       y: -1000,
//     },
//     animate: (i) => ({
//       opacity: 1,
//       y: 0,
//       transition: {
//         delay: i * 0.3,
//         duration: 1,
//       },
//     }),
//   };
//   const [expanded, setExpanded] = React.useState(0);
//   const navigate = useNavigate();
//   return (
//     <section className="bg-gradient-to-b from-[#01295c] via-slate-900 to-[#000000] p-6 flex flex-col items-center">
//       <div className="grid gap-6 w-full max-w-7xl mx-auto grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
//         {prices.map((item, i) => (
//           <motion.div
//             key={i}
//             custom={i}
//             initial="initial"
//             animate="animate"
//             variants={packageVariants}
//             className="bg-blue-600  rounded-lg p-6 flex flex-col border-2 shadow-xl hover:scale-105 transition-transform duration-300"
//           >
//             <h1 className="text-white font-bold text-2xl text-center mb-4">
//               {item.heading}
//             </h1>

//             <table className="table-fixed w-full text-white text-lg">
//               <tbody>
//                 {["monthly", "quarterly", "halfYearly", "yearly"].map((key, index) => (
//                   <tr key={index} className="border-b border-gray-400">
//                     <th className="p-3 capitalize">{key.replace(/([A-Z])/g, ' $1')}</th>
//                     <td className="text-center p-3">{item.prices[index][key] || "-"}</td>
//                     <td className="text-center p-3">
//                       {item.prices[index][key] ? (
//                         <motion.button
//                           whileHover={{ scale: 1.1 }}
//                           whileTap={{ scale: 0.9 }}
//                           // onClick={() =>
//                           //   navigate(
//                           //     `{https://equityresearchmart.in}/equity-package-payment?service=${item.heading}&price=${item.prices[index][key]}&duration=${index === 0 ? 1 : index === 1 ? 3 : index === 2 ? 6 : 12}`
//                           //   )
//                           //}
//                           className="border border-gray-600 rounded px-2 py-2 bg-green-600 hover:bg-green-500 text-white transition-colors" target="blank"
//                         >
//                           <Link to={`${apiendpoints.footerlinkurl}/equity-package-payment?service=${item.heading}&price=${item.prices[index][key]}&duration=${index === 0 ? 1 : index === 1 ? 3 : index === 2 ? 6 : 12}`}  target="blank">
//                         <p className="text-white hover:text-blueGray-800 font-normal block md:pb-2 text-sm">
//                         Buy Now
//                         </p>
//                       </Link>
                          
//                         </motion.button>
//                       ) : (
//                         "-"
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </motion.div>
//         ))}
//       </div>
//     </section>
//   );
// }

// export default Pricing;
